import React from "react";
import Header from '../components/Header';
import MainContent from '../components/MainContent';
import { SchoolTeacherContextProvider } from '../contexts/SchoolTeacherContext';
import { MenuContextProvider } from '../contexts/MenuContext';
import { TimeContextProvider } from "../contexts/TimeContext";
import { GeneralContextProvider } from "../contexts/GeneralContext";

const Portal = () => {
        return (
                <MenuContextProvider>
                        <SchoolTeacherContextProvider>
                                <GeneralContextProvider>
                                        <TimeContextProvider>
                                                <Header />
                                                <MainContent />
                                        </TimeContextProvider>
                                </GeneralContextProvider>
                        </SchoolTeacherContextProvider>
                </MenuContextProvider>
        );
}

export default Portal;
